/**
 * External dependencies
 */
import inherits from 'inherits';

export default class VisualDeckPlan {
    
    constructor(cscom) {
        if (!(this instanceof VisualDeckPlan)) {
            return new VisualDeckPlan(cscom);
        }
        this.cscom = cscom;
    }

    list(data) {
        return this.cscom.req.get('/customer-site-api/visual-deck-plans/list', null, data);
    }

    get(data) {
        return this.cscom.req.get('/customer-site-api/visual-deck-plans/view', null, data);
    }    
}
